import React from "react"
import { useState, useEffect, useRef } from "react"
import { Add, Remove, Upload } from "@mui/icons-material"
import { useLocation, useNavigate, useParams } from "react-router-dom"
import {
  ApiGetShopperDetails,
  ApiGetShopperRelativeVenues,
  ApiGetVenueList,
  ApiPutShopperDetails,
  ApiPutShopperFinancialDetails,
  ApiPutUpdateShopperApplicationStatus,
  ApiGetClients,
  ApiGetClientEntities,
  ApiGetShopperList,
} from "../../../apiService/Core/Apicall.tsx"
import { toast } from "react-toastify"
import { Button } from "@mui/material"
import { setLoadingFalse, setLoadingTrue } from "../../../global/config/Action/loadingActions.ts"
import store, { type RootState } from "../../../global/config/store.ts"
import imageCompression from "browser-image-compression"
import { CustomUploadProfilePic } from "../../../apiService/Core/CustomUploadProfilePic.tsx"
import { useSelector } from "react-redux"

// Define types for our dropdown data
interface Client {
  id: string
  name: string
}

interface ClientEntity {
  clientEntityId: string
  entityName: string
}

interface Business {
  id: string
  clientId: string
  name: string
}

interface Venue {
  id: string
  clientEntityId: string
  name: string
}

interface VenueSelection {
  clientId: string
  selectedClientId: string
  clientEntityId: string
  venueId: string
  clientsList: any[]
  clientEntityList: any[]
  venueList: any[]
}

const EditShopperProfile = () => {
  const location = useLocation()
  // const shopperDetails = location?.state?.shopperDetails || JSON.parse(sessionStorage.getItem('userDetailsState') || '{}')
  const { id } = useParams()
  const [shopperDetails, setshopperDetails] = useState<any>()
  const navigate = useNavigate()

  // Form state
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    emailId: "",
    contactNo: "",
    address: "",
    dob: "",
    gender: "",
    workForAldi: false,
    workForBlooms: false,
    workForHotelpub: false,
    hotelPubName: "",
    isShopperBuyAlcohol: false,
    shoppperDetail: "",
    isShopperCanVisitSmokingArea: false,
    isShopperCanDoGambling: false,
    isShopperCanWorkForTransport: false,
  })

  const [bankDetails, setBankDetails] = useState({
    bankName: "",
    bic: "",
    accountNo: "",
    ABNNumber: "",
  })

  // File state
  const [profileImage, setProfileImage] = useState<string | null>(null)
  const [profileImageFile, setProfileImageFile] = useState<File | null>(null)
  const [documentImage, setDocumentImage] = useState<string | null>(null)
  const [documentImageFile, setDocumentImageFile] = useState<File | null>(null)
  const Latitude: number = shopperDetails?.latitude
  const Longitude: number = shopperDetails?.longitude
  const [latNew, setLat] = useState<number>(Latitude || 0)
  const [lngNew, setLng] = useState<number>(Longitude || 0)
  const [mapAddress, setAddress] = useState<any>()
  // Add a new state for address suggestions:
  const [addressSuggestions, setAddressSuggestions] = useState<any[]>([])
  const [showSuggestions, setShowSuggestions] = useState<boolean>(false)
  const [allSelectedVenueIds, setAllSelectedVenueIds] = useState<string>("")
  const [rejectionReason, setRejectionReason] = useState<string>("")

  const inputRef = useRef<HTMLInputElement>(null)
  const autocompleteRef = useRef<any>(null)

  const Clientlist = useSelector((state: RootState) => state.client.clientList)
  console.log(Clientlist)

  // Initialize venue selections with proper structure including clients
  const [venueSelections, setVenueSelections] = useState<VenueSelection[]>([
    {
      clientId: "",
      selectedClientId: "",
      clientEntityId: "",
      venueId: "",
      clientsList: [],
      clientEntityList: [],
      venueList: [],
    },
  ])



  // Venue selection handlers with proper isolation
  const addVenueSelection = () => {
    setVenueSelections([
      ...venueSelections,
      {
        clientId: "",
        selectedClientId: "",
        clientEntityId: "",
        venueId: "",
        clientsList: [],
        clientEntityList: [],
        venueList: [],
      },
    ])
  }

  const removeVenueSelection = (index: number) => {
    if (venueSelections.length > 1) {
      const updatedSelections = [...venueSelections]
      updatedSelections.splice(index, 1)
      setVenueSelections(updatedSelections)
    }
  }

  const handleClientDbChange = async (index: number, clientId: string) => {
    const updatedSelections = [...venueSelections]
    updatedSelections[index] = {
      ...updatedSelections[index],
      clientId,
      selectedClientId: "",
      clientEntityId: "",
      venueId: "",
      clientsList: [],
      clientEntityList: [],
      venueList: [],
    }

    // Fetch clients for this specific selection
    if (clientId) {
      try {
        const data = `?clientGroup=${clientId}&status=active&offset=0&limit=100`
        const response: any = await ApiGetClients(data)
        updatedSelections[index].clientsList = response.data || []
      } catch (error) {
        console.error("Error during API call:", error)
      }
    }

    setVenueSelections(updatedSelections)
  }

  const handleClientChange = async (index: number, selectedClientId: string) => {
    const updatedSelections = [...venueSelections]
    updatedSelections[index] = {
      ...updatedSelections[index],
      selectedClientId,
      clientEntityId: "",
      venueId: "",
      clientEntityList: [],
      venueList: [],
    }

    // Fetch client entities for this specific selection
    if (selectedClientId) {
      try {
        const data = `?clientId=${selectedClientId}&offset=0&limit=100&clientEntityStatus=active`
        const response: any = await ApiGetClientEntities(data)
        console.log("clientEntity list", response.data)
        updatedSelections[index].clientEntityList =
          response.data.map((clientEntity: any) => ({
            label: clientEntity.entityName,
            value: clientEntity.clientEntityId,
            clientEntityId: clientEntity.clientEntityId,
            entityName: clientEntity.entityName,
          })) || []
      } catch (error) {
        console.error("Error during API call:", error)
      }
    }

    setVenueSelections(updatedSelections)
  }
  console.log(venueSelections)

  const handleBusinessChange = async (index: number, clientEntityId: string) => {
    const updatedSelections = [...venueSelections]
    updatedSelections[index] = {
      ...updatedSelections[index],
      clientEntityId,
      venueId: "",
      venueList: [],
    }

    // Fetch venues for this specific selection
    if (clientEntityId) {
      try {
        const data = `?clientEntityId=${clientEntityId}&offset=0&limit=500&venueStatus=active`
        const res = await ApiGetVenueList(data)
        const venueOptions =
          res?.data?.map((item: any) => ({
            label: item.venueName,
            value: item.venueId,
          })) || []
        updatedSelections[index].venueList = venueOptions
      } catch (error) {
        console.error("Error fetching venues:", error)
      }
    }

    setVenueSelections(updatedSelections)
  }

  const handleVenueChange = (index: number, venueId: string) => {
    const updatedSelections = [...venueSelections]
    updatedSelections[index].venueId = venueId
    setVenueSelections(updatedSelections)

    // Update comma-separated venue ID list
    const selectedVenueIds = updatedSelections.map((selection) => selection.venueId).filter((id) => id) // remove empty values

    setAllSelectedVenueIds(selectedVenueIds.join(","))
  }
  console.log(allSelectedVenueIds)

  // Get all selected venue IDs
  const getSelectedVenueIds = () => {
    return venueSelections.map((selection) => selection.venueId).filter((id) => id)
  }

  // Function to prepopulate venue selections from relative venues data
  const prepopulateVenueSelections = async (relativeVenues: any[]) => {
    if (!relativeVenues || relativeVenues.length === 0) return

    const prepopulatedSelections: VenueSelection[] = []

    for (const venue of relativeVenues) {
      try {
        // Find the client group from Clientlist using clientId
        const clientGroup = Clientlist.find(
          (client) => client.id === venue.clientId || client.clientId === venue.clientId,
        )

        let clientsListById: any[] = []
        let clientEntityList: any[] = []
        let venueList: any[] = []
        let clientsList: any[] = []

        // Fetch clients for this clientId
        if (venue.clientId) {
          try {
            const clientsData = `?clientId=${venue.clientId}&status=active&offset=0&limit=100`
            const clientsResponse: any = await ApiGetClients(clientsData)
            clientsListById = clientsResponse.data || []
            console.log("client dbname", clientsListById);
          } catch (error) {
            console.error("Error fetching clients:", error)
          }
        }

        // Fetch client entities
        if (venue.clientId) {
          try {
            const entitiesData = `?clientId=${venue.clientId}&offset=0&limit=100&clientEntityStatus=active`
            const entitiesResponse: any = await ApiGetClientEntities(entitiesData)
            clientEntityList =
              entitiesResponse.data.map((clientEntity: any) => ({
                label: clientEntity.entityName,
                value: clientEntity.clientEntityId,
                clientEntityId: clientEntity.clientEntityId,
                entityName: clientEntity.entityName,
              })) || []
          } catch (error) {
            console.error("Error fetching client entities:", error)
          }
        }

        // Fetch venues
        if (venue.clientEntityId) {
          try {
            const venuesData = `?clientEntityId=${venue.clientEntityId}&offset=0&limit=500&venueStatus=active`
            const venuesResponse = await ApiGetVenueList(venuesData)
            venueList =
              venuesResponse?.data?.map((item: any) => ({
                label: item.venueName,
                value: item.venueId,
              })) || []
          } catch (error) {
            console.error("Error fetching venues:", error)
          }
        }


        try {
          const clientsData = `?clientGroup=${clientsListById[0].ClientGroupName.clientGroupName}&status=active&offset=0&limit=100`
          const clientsResponse: any = await ApiGetClients(clientsData)
          clientsList = clientsResponse.data || []
          console.log("client dbname", clientsList);
        } catch (error) {
          console.error("Error fetching clients:", error)
        }


        prepopulatedSelections.push({
          clientId: clientsListById[0].ClientGroupName.clientGroupName,
          selectedClientId: venue.clientId.toString(),
          clientEntityId: venue.clientEntityId.toString(),
          venueId: venue.venueId.toString(),
          clientsList,
          clientEntityList,
          venueList,
        })
      } catch (error) {
        console.error("Error prepopulating venue selection:", error)
      }
    }

    if (prepopulatedSelections.length > 0) {
      setVenueSelections(prepopulatedSelections)

      // Update the selected venue IDs string
      const selectedVenueIds = prepopulatedSelections.map((selection) => selection.venueId).filter((id) => id)
      setAllSelectedVenueIds(selectedVenueIds.join(","))
    }
  }
  // Initialize form data from shopperDetails
  useEffect(() => {
    const fetchShoppeDetails = async () => {
      if (id) {
        const data = `/${id}`
        try {
          const response: any = await ApiGetShopperDetails(data)
          if (response.data) {
            setshopperDetails(response.data)
            setFormData({
              firstName: response.data?.firstName || "",
              lastName: response.data?.lastName || "",
              emailId: response.data?.emailId || "",
              contactNo: response.data?.contactNo || "",
              address: `${response.data?.address} ${response?.data?.city ? response?.data?.city : ''} ${response?.data?.state}, ${response?.data?.country}` || "",
              dob: response.data.dob ? new Date(response.data?.dob).toISOString().split("T")[0] : "",
              gender: response.data?.gender || "",
              workForAldi: response.data?.workForAldi || false,
              workForBlooms: response.data?.workForBlooms || false,
              workForHotelpub: response.data?.workForHotelpub || false,
              hotelPubName: response.data?.hotelPubName || "",
              isShopperBuyAlcohol: response.data?.shopperOtherDetail?.isShopperBuyAlcohol || false,
              shoppperDetail: response.data?.shopperOtherDetail?.shoppperDetail || "",
              isShopperCanVisitSmokingArea: response.data?.shopperOtherDetail?.isShopperCanVisitSmokingArea || false,
              isShopperCanDoGambling: response.data?.shopperOtherDetail?.isShopperCanDoGambling || false,
              isShopperCanWorkForTransport: response.data?.shopperOtherDetail?.isShopperCanWorkForTransport || false,
            })
            setBankDetails({
              bankName: response.data?.bankName,
              bic: response.data?.bic,
              accountNo: response.data?.accountNo,
              ABNNumber: response.data?.shopperOtherDetail?.ABNNumber,
            })

            setLat(response.data?.latitude)
            setLng(response.data?.longitude)

            setRejectionReason(response.data?.shopperOtherDetail?.shopperRejectedReason || "")

            // Set initial images
            if (response.data?.profilePicUrl) {
              setProfileImage(response.data?.profilePicUrl)
            }
            if (response.data?.driving_licence) {
              setDocumentImage(response.data?.driving_licence)
            }

            try {
              const data = `?userId=${response.data.userId}`
              const relativeVenueResponse = await ApiGetShopperRelativeVenues(data)
              console.log("relative venues", relativeVenueResponse)

              // Prepopulate venue selections if data exists
              if (relativeVenueResponse?.data && relativeVenueResponse.data.length > 0) {
                await prepopulateVenueSelections(relativeVenueResponse.data)
              }
            } catch (err) {
              console.error("Error fetching additional info:", err)
            }
          }
        } catch (error) {
          console.error("Error during API call:", error)
        }
      }
    }
    fetchShoppeDetails()
  }, [id])

  // Add a new useEffect to update the address when mapAddress changes
  useEffect(() => {
    if (mapAddress && mapAddress.formatted_address) {
      setFormData((prev) => ({
        ...prev,
        address: mapAddress.formatted_address,
      }))
    }
  }, [mapAddress])

  useEffect(() => {
    const loadAutocomplete = async () => {
      if (!window.google) {
        console.error("Google Maps API is not loaded.")
        return
      }

      if (!inputRef.current) {
        console.error("Input reference is null.")
        return
      }

      try {
        autocompleteRef.current = new window.google.maps.places.Autocomplete(inputRef.current as HTMLInputElement, {
          types: ["geocode"],
          componentRestrictions: { country: "AU" },
        })

        autocompleteRef.current.addListener("place_changed", async () => {
          const place = await autocompleteRef.current.getPlace()

          if (!place || !place.formatted_address) {
            console.warn("No address found.")
            return
          }

          setFormData((prev) => ({
            ...prev,
            address: place.formatted_address,
          }))

          if (place.geometry?.location) {
            setLat(place.geometry.location.lat())
            setLng(place.geometry.location.lng())
          }
        })
      } catch (error) {
        console.error("Error initializing autocomplete:", error)
      }
    }

    loadAutocomplete()
  }, [])

  // Handle input changes
  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }))
    setBankDetails((prev) => ({
      ...prev,
      [name]: value,
    }))
  }

  // Handle radio button changes
  const handleRadioChange = (name: string, value: boolean) => {
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }))
  }

  const uploadImage = async (file: File) => {
    store.dispatch(setLoadingTrue())
    console.log("FIle", file)
    const formData = new FormData()
    formData.append("file", file)
    formData.append("fileType", "profile_pic")
    formData.append("userId", shopperDetails?.userId)

    console.log("file", file)

    try {
      const response = await CustomUploadProfilePic(formData)
      store.dispatch(setLoadingFalse())
      toast.success("File uploaded successfully")
      setProfileImage(response.location)
    } catch (error) {
      console.error("Error uploading file:", error)
      toast.error(error)
    }
  }

  const uploadDocumentImage = async (file: File) => {
    store.dispatch(setLoadingTrue())
    console.log("FIle", file)
    const formData = new FormData()
    formData.append("file", file)
    formData.append("fileType", "driving_licence")
    formData.append("userId", shopperDetails?.userId)

    console.log("file", file)

    try {
      const response = await CustomUploadProfilePic(formData)
      store.dispatch(setLoadingFalse())
      toast.success("File uploaded successfully")
      setDocumentImage(response.location)
    } catch (error) {
      console.error("Error uploading file:", error)
      toast.error(error)
    }
  }

  // Handle file uploads
  const handleProfileImageUpload = async (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files ? event.target.files[0] : null
    if (file) {
      store.dispatch(setLoadingTrue())
      try {
        // Compression options
        const options = {
          maxSizeMB: 1,
          maxWidthOrHeight: 1024,
          useWebWorker: true,
        }

        const compressedFile = await imageCompression(file, options)

        // Upload compressed file
        uploadImage(compressedFile)
      } catch (error) {
        console.error("Image compression failed:", error)
      }
    }
  }

  // const handleDocumentUpload = async (event: React.ChangeEvent<HTMLInputElement>) => {
  //   const file = event.target.files ? event.target.files[0] : null
  //   if (file) {
  //     store.dispatch(setLoadingTrue())
  //     try {
  //       // Compression options
  //       const options = {
  //         maxSizeMB: 1,
  //         maxWidthOrHeight: 1024,
  //         useWebWorker: true,
  //       }

  //       const compressedFile = await imageCompression(file, options)

  //       // Upload compressed file
  //       uploadDocumentImage(compressedFile)
  //     } catch (error) {
  //       console.error("Image compression failed:", error)
  //     }
  //   }
  // }

  const handleDocumentUpload = async (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const file = event.target.files?.[0];

    if (!file) return;

    store.dispatch(setLoadingTrue());

    try {
      let fileToUpload = file;

      if (file.type.startsWith("image/")) {
        // Compress images only
        const options = {
          maxSizeMB: 1,
          maxWidthOrHeight: 1024,
          useWebWorker: true,
        };

        fileToUpload = await imageCompression(file, options);
      } else if (file.type !== "application/pdf") {
        console.error("Unsupported file type");
        return;
      }

      // Upload compressed image or original PDF
      await uploadDocumentImage(fileToUpload);
    } catch (error) {
      console.error("Document upload failed:", error);
    } finally {
      store.dispatch(setLoadingFalse());
      event.target.value = "";
    }
  };

  // Handle form submission
  const handleSubmit = async () => {
    try {
      // Create form data for API
      const data = {
        userId: shopperDetails.userId,
        ...formData,
        latitude: latNew,
        longitude: lngNew,
        profilePicUrl: profileImage,
        driving_licence: documentImage,
        relativeVenueIds: allSelectedVenueIds,
        isFirstTimeUpdate: false,
      }
      console.log(data)
      //Call API to update profile
      const response = await ApiPutShopperDetails(data)
      const bankData = {
        userId: shopperDetails.userId,
        ...bankDetails,
      }
      const res = await ApiPutShopperFinancialDetails(bankData)
      if (res) {
        toast.success("Profile updated successfully")
        navigate(-1)
      } else {
        toast.error("Failed to update profile")
      }
    } catch (error) {
      console.error("Error updating profile:", error)
      toast.error("An error occurred while updating profile")
    }
  }

  const updateApplicationStatus = async (shopper: any, updatedStatus: any) => {
    const data = {
      userId: shopper.userId,
      status: updatedStatus,
    }
    const response: any = await ApiPutUpdateShopperApplicationStatus(data)
    toast.success("Application Status updated successfully")
    navigate(-1)
  }

  // Custom styles to override external CSS
  const formStyles = {
    container: {
      maxWidth: "1200px",
      margin: "0 auto",
      padding: "20px",
      borderRadius: "10px",
      fontFamily: "Arial, sans-serif",
      backgroundColor: "#fff",
    },
    section: {
      marginBottom: "30px",
      borderBottom: "1px solid #f0f0f0",
      paddingBottom: "20px",
    },
    sectionTitle: {
      fontSize: "18px",
      fontWeight: "bold",
      color: "#333",
      marginBottom: "5px",
      display: "flex",
      alignItems: "center",
    },
    sectionNumber: {
      marginRight: "8px",
    },
    sectionDescription: {
      fontSize: "14px",
      color: "#666",
      marginBottom: "15px",
    },
    formRow: {
      display: "flex",
      flexWrap: "wrap",
      margin: "0 -10px",
      marginBottom: "15px",
    },
    formColumn: {
      flex: "1 0 calc(50% - 20px)",
      margin: "0 10px",
      minWidth: "250px",
    },
    formColumnFull: {
      flex: "1 0 calc(100% - 20px)",
      margin: "0 10px",
    },
    formColumnThird: {
      flex: "1 0 calc(33.333% - 20px)",
      margin: "0 10px",
      minWidth: "200px",
    },
    formColumnQuarter: {
      flex: "1 0 calc(25% - 20px)",
      margin: "0 10px",
      minWidth: "180px",
    },
    inputLabel: {
      display: "block",
      fontSize: "14px",
      marginBottom: "5px",
      color: "#333",
    },
    requiredStar: {
      color: "red",
      marginLeft: "2px",
    },
    textField: {
      width: "100%",
      padding: "8px 12px",
      border: "1px solid #ddd",
      borderRadius: "4px",
      fontSize: "14px",
      boxSizing: "border-box",
    },
    radioGroup: {
      display: "flex",
      alignItems: "center",
      marginTop: "5px",
    },
    radioLabel: {
      marginRight: "20px",
      display: "flex",
      alignItems: "center",
      fontSize: "14px",
    },
    radioInput: {
      marginRight: "5px",
      width: "16px",
      height: "16px",
      accentColor: "#1976d2",
      cursor: "pointer",
    },
    uploadBox: {
      border: "1px dashed #ccc",
      borderRadius: "4px",
      height: "200px",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      cursor: "pointer",
      width: "50%",
      position: "relative" as const,
    },
    uploadIcon: {
      fontSize: "24px",
      color: "#666",
      marginBottom: "8px",
    },
    uploadText: {
      fontSize: "14px",
      color: "#666",
    },
    textareaField: {
      width: "100%",
      padding: "8px 12px",
      border: "1px solid #ddd",
      borderRadius: "4px",
      fontSize: "14px",
      minHeight: "100px",
      boxSizing: "border-box",
      resize: "vertical",
    },
    wordCount: {
      fontSize: "12px",
      color: "#666",
      textAlign: "right",
      marginTop: "5px",
    },
    buttonContainer: {
      display: "flex",
      justifyContent: "center",
      gap: "10px",
      marginTop: "20px",
    },
    button: {
      padding: "10px 20px",
      backgroundColor: "#1976d2",
      color: "white",
      border: "none",
      borderRadius: "4px",
      cursor: "pointer",
      fontSize: "14px",
      fontWeight: "bold",
    },
    otherDetailsContainer: {
      display: "flex",
      flexWrap: "wrap",
      gap: "15px",
      marginBottom: "20px",
    },
    otherDetailsItem: {
      flex: "1 0 200px",
      minWidth: "200px",
    },
    questionContainer: {
      marginBottom: "10px",
    },
    fileInput: {
      position: "absolute" as const,
      width: "100%",
      height: "100%",
      opacity: 0,
      cursor: "pointer",
    },
    // Clean dropdown styles matching the image design
    dropdownContainer: {
      display: "flex",
      alignItems: "center",
      gap: "15px",
      marginBottom: "15px",
      flexWrap: "wrap",
    },
    dropdown: {
      width: "200px",
      height: "45px",
      padding: "0 15px",
      border: "1px solid #d1d5db",
      borderRadius: "8px",
      fontSize: "14px",
      color: "#6b7280",
      backgroundColor: "#ffffff",
      cursor: "pointer",
      outline: "none",
      appearance: "none",
      backgroundImage: `url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 20 20'%3e%3cpath stroke='%236b7280' strokeLinecap='round' strokeLinejoin='round' strokeWidth='1.5' d='m6 8 4 4 4-4'/%3e%3c/svg%3e")`,
      backgroundPosition: "right 12px center",
      backgroundRepeat: "no-repeat",
      backgroundSize: "16px",
      transition: "border-color 0.15s ease-in-out",
    },
    dropdownFocus: {
      borderColor: "#3b82f6",
      boxShadow: "0 0 0 3px rgba(59, 130, 246, 0.1)",
    },
    iconButton: {
      width: "36px",
      height: "36px",
      borderRadius: "50%",
      border: "none",
      cursor: "pointer",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      fontSize: "18px",
      transition: "all 0.2s ease",
    },
    addButton: {
      backgroundColor: "#10b981",
      color: "white",
      "&:hover": {
        backgroundColor: "#059669",
      },
    },
    removeButton: {
      backgroundColor: "#ef4444",
      color: "white",
      "&:hover": {
        backgroundColor: "#dc2626",
      },
    },
  }

  // Add a click handler to the document to close suggestions when clicking outside:
  useEffect(() => {
    const handleClickOutside = () => {
      setShowSuggestions(false)
    }

    document.addEventListener("click", handleClickOutside)

    return () => {
      document.removeEventListener("click", handleClickOutside)
    }
  }, [])


  return (
    <div className="w-100 p-2">
      <div style={formStyles.container}>
        {/* Personal Details Section */}
        <div style={formStyles.section}>
          <div style={formStyles.sectionTitle}>
            <span style={formStyles.sectionNumber}>1.</span> Personal Details
          </div>
          <div style={formStyles.sectionDescription}>Tell us a little about yourself.</div>

          <div style={{ display: "flex", flexWrap: "wrap" }}>
            <div style={{ flex: "1 1 65%", paddingRight: "20px" }}>
              <div style={formStyles.formRow}>
                <div style={formStyles.formColumn}>
                  <label style={formStyles.inputLabel}>
                    First Name <span style={formStyles.requiredStar}>*</span>
                  </label>
                  <input
                    type="text"
                    name="firstName"
                    style={formStyles.textField}
                    value={formData.firstName}
                    onChange={handleInputChange}
                  />
                </div>
                <div style={formStyles.formColumn}>
                  <label style={formStyles.inputLabel}>
                    Last Name <span style={formStyles.requiredStar}>*</span>
                  </label>
                  <input
                    type="text"
                    name="lastName"
                    style={formStyles.textField}
                    value={formData.lastName}
                    onChange={handleInputChange}
                  />
                </div>
              </div>

              <div style={formStyles.formRow}>
                <div style={formStyles.formColumn}>
                  <label style={formStyles.inputLabel}>
                    Email <span style={formStyles.requiredStar}>*</span>
                  </label>
                  <input
                    type="email"
                    name="emailId"
                    style={formStyles.textField}
                    value={formData.emailId}
                    onChange={handleInputChange}
                  />
                </div>
                <div style={formStyles.formColumn}>
                  <label style={formStyles.inputLabel}>
                    Mobile <span style={formStyles.requiredStar}>*</span>
                  </label>
                  <input
                    type="text"
                    name="contactNo"
                    style={formStyles.textField}
                    value={formData.contactNo}
                    onChange={handleInputChange}
                  />
                </div>
              </div>

              <div style={formStyles.formRow}>
                <div style={formStyles.formColumnFull}>
                  <label style={formStyles.inputLabel}>
                    Address <span style={formStyles.requiredStar}>*</span>
                  </label>
                  <input
                    ref={inputRef}
                    type="text"
                    name="address"
                    style={formStyles.textField}
                    value={formData.address}
                    onChange={handleInputChange}
                  />
                </div>
              </div>

              <div style={formStyles.formRow}>
                <div style={formStyles.formColumn}>
                  <label style={formStyles.inputLabel}>
                    D.O.B <span style={formStyles.requiredStar}>*</span>
                  </label>
                  <input
                    type="date"
                    name="dob"
                    style={formStyles.textField}
                    value={formData.dob}
                    onChange={handleInputChange}
                  />
                </div>
                <div style={formStyles.formColumn}>
                  <label style={formStyles.inputLabel}>
                    Gender <span style={formStyles.requiredStar}>*</span>
                  </label>
                  <div style={formStyles.radioGroup}>
                    <label style={formStyles.radioLabel}>
                      <input
                        type="radio"
                        name="gender"
                        style={formStyles.radioInput}
                        checked={formData.gender === "Male"}
                        onChange={() => handleRadioChange("gender", "Male")}
                      />
                      Male
                    </label>
                    <label style={formStyles.radioLabel}>
                      <input
                        type="radio"
                        name="gender"
                        style={formStyles.radioInput}
                        checked={formData.gender === "Female"}
                        onChange={() => handleRadioChange("gender", "Female")}
                      />
                      Female
                    </label>
                  </div>
                </div>
              </div>

              <div style={formStyles.formRow}>
                <div style={formStyles.formColumn}>
                  <label style={formStyles.inputLabel}>
                    Latitude <span style={formStyles.requiredStar}>*</span>
                  </label>
                  <input type="text" name="firstName" style={formStyles.textField} value={latNew} />
                </div>
                <div style={formStyles.formColumn}>
                  <label style={formStyles.inputLabel}>
                    Longitude <span style={formStyles.requiredStar}>*</span>
                  </label>
                  <input type="text" name="lastName" style={formStyles.textField} value={lngNew} />
                </div>
              </div>
            </div>

            <div style={{ flex: "1 1 35%" }}>
              <label style={formStyles.inputLabel}>
                Profile Image <span style={formStyles.requiredStar}>*</span>
              </label>
              <div style={formStyles.uploadBox}>
                {profileImage ? (
                  <img
                    src={profileImage || "/placeholder.svg"}
                    alt="Profile"
                    style={{
                      maxHeight: "100%",
                      maxWidth: "100%",
                      objectFit: "contain",
                    }}
                  />
                ) : (
                  <>
                    <div style={formStyles.uploadIcon}>
                      <Upload />
                    </div>
                    <div style={formStyles.uploadText}>Upload Here</div>
                  </>
                )}
                <input type="file" accept="image/*" style={formStyles.fileInput} onChange={handleProfileImageUpload} />
              </div>
            </div>
          </div>
        </div>

        {/* Bank Details Section */}
        <div style={formStyles.section}>
          <div style={formStyles.sectionTitle}>
            <span style={formStyles.sectionNumber}>2.</span> Bank Details
          </div>

          <div style={formStyles.otherDetailsContainer}>
            <div style={formStyles.otherDetailsItem}>
              <div style={formStyles.questionContainer}>
                <label style={formStyles.inputLabel}>
                  Bank Name <span style={formStyles.requiredStar}>*</span>
                </label>
                <input
                  type="text"
                  name="bankName"
                  style={formStyles.textField}
                  value={bankDetails.bankName}
                  onChange={handleInputChange}
                />
              </div>
            </div>

            <div style={formStyles.otherDetailsItem}>
              <div style={formStyles.questionContainer}>
                <label style={formStyles.inputLabel}>
                  BIC No <span style={formStyles.requiredStar}>*</span>
                </label>
                <input
                  type="text"
                  name="bic"
                  style={formStyles.textField}
                  value={bankDetails.bic}
                  onChange={handleInputChange}
                />
              </div>
            </div>

            <div style={formStyles.otherDetailsItem}>
              <div style={formStyles.questionContainer}>
                <label style={formStyles.inputLabel}>
                  Account No <span style={formStyles.requiredStar}>*</span>
                </label>
                <input
                  type="text"
                  name="accountNo"
                  style={formStyles.textField}
                  value={bankDetails.accountNo}
                  onChange={handleInputChange}
                />
              </div>
            </div>

            <div style={formStyles.otherDetailsItem}>
              <div style={formStyles.questionContainer}>
                <label style={formStyles.inputLabel}>
                  ABN No <span style={formStyles.requiredStar}>*</span>
                </label>
                <input
                  type="text"
                  name="ABNNumber"
                  style={formStyles.textField}
                  value={bankDetails.ABNNumber}
                  onChange={handleInputChange}
                />
              </div>
            </div>
          </div>
        </div>

        {/* Other Details Section */}
        <div style={formStyles.section}>
          <div style={formStyles.sectionTitle}>
            <span style={formStyles.sectionNumber}>3.</span> Other Details
          </div>
          <div style={formStyles.sectionDescription}>These details help us match you to the right tasks</div>

          <div style={formStyles.otherDetailsContainer}>
            <div style={formStyles.otherDetailsItem}>
              <div style={formStyles.questionContainer}>
                <label style={formStyles.inputLabel}>
                  Do you or an immediate family member or close friend work for ALDI?{" "}
                  <span style={formStyles.requiredStar}>*</span>
                </label>
                <div style={formStyles.radioGroup}>
                  <label style={formStyles.radioLabel}>
                    <input
                      type="radio"
                      name="workForAldi"
                      style={formStyles.radioInput}
                      checked={formData.workForAldi === true}
                      onChange={() => handleRadioChange("workForAldi", true)}
                    />
                    Yes
                  </label>
                  <label style={formStyles.radioLabel}>
                    <input
                      type="radio"
                      name="workForAldi"
                      style={formStyles.radioInput}
                      checked={formData.workForAldi === false}
                      onChange={() => handleRadioChange("workForAldi", false)}
                    />
                    No
                  </label>
                </div>
              </div>
            </div>

            <div style={formStyles.otherDetailsItem}>
              <div style={formStyles.questionContainer}>
                <label style={formStyles.inputLabel}>
                  Do you or an immediate family member or close friend work for BLOOMS the Chemist?{" "}
                  <span style={formStyles.requiredStar}>*</span>
                </label>
                <div style={formStyles.radioGroup}>
                  <label style={formStyles.radioLabel}>
                    <input
                      type="radio"
                      name="workForBlooms"
                      style={formStyles.radioInput}
                      checked={formData.workForBlooms === true}
                      onChange={() => handleRadioChange("workForBlooms", true)}
                    />
                    Yes
                  </label>
                  <label style={formStyles.radioLabel}>
                    <input
                      type="radio"
                      name="workForBlooms"
                      style={formStyles.radioInput}
                      checked={formData.workForBlooms === false}
                      onChange={() => handleRadioChange("workForBlooms", false)}
                    />
                    No
                  </label>
                </div>
              </div>
            </div>

            <div style={formStyles.otherDetailsItem}>
              <div style={formStyles.questionContainer}>
                <label style={formStyles.inputLabel}>
                  Do you or an immediate family member or close friend work for a hotel/pub chain?{" "}
                  <span style={formStyles.requiredStar}>*</span>
                </label>
                <div style={formStyles.radioGroup}>
                  <label style={formStyles.radioLabel}>
                    <input
                      type="radio"
                      name="workForHotelpub"
                      style={formStyles.radioInput}
                      checked={formData.workForHotelpub === true}
                      onChange={() => handleRadioChange("workForHotelpub", true)}
                    />
                    Yes
                  </label>
                  <label style={formStyles.radioLabel}>
                    <input
                      type="radio"
                      name="workForHotelpub"
                      style={formStyles.radioInput}
                      checked={formData.workForHotelpub === false}
                      onChange={() => handleRadioChange("workForHotelpub", false)}
                    />
                    No
                  </label>
                </div>
              </div>
            </div>

            {formData.workForHotelpub === true && (
              <div style={formStyles.otherDetailsItem}>
                <div style={formStyles.formColumnFull}>
                  <label style={formStyles.inputLabel}>Hotel/Pub Name</label>
                  <input
                    type="text"
                    name="hotelPubName"
                    style={formStyles.textField}
                    value={formData.hotelPubName}
                    onChange={handleInputChange}
                  />
                </div>
              </div>
            )}
          </div>

          {/* Updated Venue Selection Dropdowns with new Client dropdown */}
          {formData.workForHotelpub === true && (
            <div style={formStyles.formRow}>
              <div style={formStyles.formColumnFull}>
                <label style={formStyles.inputLabel}>
                  Select Sites <span style={formStyles.requiredStar}>*</span>
                </label>

                {venueSelections.map((selection, index) => (
                  <div key={index} style={formStyles.dropdownContainer}>
                    {/* Client DBName Dropdown */}
                    <select
                      value={selection.clientId}
                      onChange={(e) => handleClientDbChange(index, e.target.value)}
                      style={formStyles.dropdown}
                    >
                      <option value="">Select DBName</option>
                      {Clientlist.map((client) => (
                        <option key={client.id} value={client.id}>
                          {client.clientGroupName}
                        </option>
                      ))}
                    </select>

                    {/* NEW: Client Dropdown - only shown if DBName is selected */}
                    {selection.clientId && selection.clientsList.length > 0 && (
                      <select
                        value={selection.selectedClientId}
                        onChange={(e) => handleClientChange(index, e.target.value)}
                        style={formStyles.dropdown}
                      >
                        <option value="">Select Client</option>
                        {selection.clientsList.map((client) => (
                          <option key={client.ClientID} value={client.ClientID}>
                            {client.ClientName}
                          </option>
                        ))}
                      </select>
                    )}

                    {/* Business Dropdown - only shown if client is selected */}
                    {selection.selectedClientId && selection.clientEntityList.length > 0 && (
                      <select
                        value={selection.clientEntityId}
                        onChange={(e) => handleBusinessChange(index, e.target.value)}
                        style={formStyles.dropdown}
                      >
                        <option value="">Select Business</option>
                        {selection.clientEntityList
                          ?.filter((item) => item.clientEntityId !== null)
                          .map((business) => (
                            <option key={business.clientEntityId} value={business.clientEntityId}>
                              {business.entityName}
                            </option>
                          ))}
                      </select>
                    )}

                    {/* Venue Dropdown - only shown if business is selected */}
                    {selection.clientEntityId && selection.venueList.length > 0 && (
                      <select
                        value={selection.venueId}
                        onChange={(e) => handleVenueChange(index, e.target.value)}
                        style={formStyles.dropdown}
                      >
                        <option value="">Search Site</option>
                        {selection.venueList.map((venue: any) => (
                          <option key={venue.value} value={venue.value}>
                            {venue.label}
                          </option>
                        ))}
                      </select>
                    )}

                    {/* Add/Remove buttons with MUI icons */}
                    {index === venueSelections.length - 1 && (
                      <button
                        type="button"
                        onClick={addVenueSelection}
                        style={{
                          ...formStyles.iconButton,
                          ...formStyles.addButton,
                        }}
                        title="Add venue selection"
                      >
                        <Add />
                      </button>
                    )}

                    {venueSelections.length > 1 && (
                      <button
                        type="button"
                        onClick={() => removeVenueSelection(index)}
                        style={{
                          ...formStyles.iconButton,
                          ...formStyles.removeButton,
                        }}
                        title="Remove venue selection"
                      >
                        <Remove />
                      </button>
                    )}
                  </div>
                ))}
              </div>
            </div>
          )}

          <div style={formStyles.otherDetailsContainer}>
            <div style={formStyles.otherDetailsItem}>
              <div style={formStyles.questionContainer}>
                <label style={formStyles.inputLabel}>
                  Are you prepared to buy alcohol? <span style={formStyles.requiredStar}>*</span>
                </label>
                <div style={formStyles.radioGroup}>
                  <label style={formStyles.radioLabel}>
                    <input
                      type="radio"
                      name="isShopperBuyAlcohol"
                      style={formStyles.radioInput}
                      checked={formData.isShopperBuyAlcohol === true}
                      onChange={() => handleRadioChange("isShopperBuyAlcohol", true)}
                    />
                    Yes
                  </label>
                  <label style={formStyles.radioLabel}>
                    <input
                      type="radio"
                      name="isShopperBuyAlcohol"
                      style={formStyles.radioInput}
                      checked={formData.isShopperBuyAlcohol === false}
                      onChange={() => handleRadioChange("isShopperBuyAlcohol", false)}
                    />
                    No
                  </label>
                </div>
              </div>
            </div>

            <div style={formStyles.otherDetailsItem}>
              <div style={formStyles.questionContainer}>
                <label style={formStyles.inputLabel}>
                  Are you prepared to go into the smoking area? <span style={formStyles.requiredStar}>*</span>
                </label>
                <div style={formStyles.radioGroup}>
                  <label style={formStyles.radioLabel}>
                    <input
                      type="radio"
                      name="isShopperCanVisitSmokingArea"
                      style={formStyles.radioInput}
                      checked={formData.isShopperCanVisitSmokingArea === true}
                      onChange={() => handleRadioChange("isShopperCanVisitSmokingArea", true)}
                    />
                    Yes
                  </label>
                  <label style={formStyles.radioLabel}>
                    <input
                      type="radio"
                      name="isShopperCanVisitSmokingArea"
                      style={formStyles.radioInput}
                      checked={formData.isShopperCanVisitSmokingArea === false}
                      onChange={() => handleRadioChange("isShopperCanVisitSmokingArea", false)}
                    />
                    No
                  </label>
                </div>
              </div>
            </div>

            <div style={formStyles.otherDetailsItem}>
              <div style={formStyles.questionContainer}>
                <label style={formStyles.inputLabel}>
                  Are you prepared to gamble? <span style={formStyles.requiredStar}>*</span>
                </label>
                <div style={formStyles.radioGroup}>
                  <label style={formStyles.radioLabel}>
                    <input
                      type="radio"
                      name="isShopperCanDoGambling"
                      style={formStyles.radioInput}
                      checked={formData.isShopperCanDoGambling === true}
                      onChange={() => handleRadioChange("isShopperCanDoGambling", true)}
                    />
                    Yes
                  </label>
                  <label style={formStyles.radioLabel}>
                    <input
                      type="radio"
                      name="isShopperCanDoGambling"
                      style={formStyles.radioInput}
                      checked={formData.isShopperCanDoGambling === false}
                      onChange={() => handleRadioChange("isShopperCanDoGambling", false)}
                    />
                    No
                  </label>
                </div>
              </div>
            </div>

            <div style={formStyles.otherDetailsItem}>
              <div style={formStyles.questionContainer}>
                <label style={formStyles.inputLabel}>
                  Is this a designated transport shopper? <span style={formStyles.requiredStar}>*</span>
                </label>
                <div style={formStyles.radioGroup}>
                  <label style={formStyles.radioLabel}>
                    <input
                      type="radio"
                      name="isShopperCanWorkForTransport"
                      style={formStyles.radioInput}
                      checked={formData?.isShopperCanWorkForTransport === true}
                      onChange={() => handleRadioChange("isShopperCanWorkForTransport", true)}
                    />
                    Yes
                  </label>
                  <label style={formStyles.radioLabel}>
                    <input
                      type="radio"
                      name="isShopperCanWorkForTransport"
                      style={formStyles.radioInput}
                      checked={formData?.isShopperCanWorkForTransport === false}
                      onChange={() => handleRadioChange("isShopperCanWorkForTransport", false)}
                    />
                    No
                  </label>
                </div>
              </div>
            </div>

            {rejectionReason && (
              <div style={formStyles.otherDetailsItem}>
                <div style={formStyles.questionContainer}>
                  <label style={formStyles.inputLabel}>
                    Deactive Reason <span style={formStyles.requiredStar}>*</span>
                  </label>
                  <input
                    type="text"
                    name="rejectionReason"
                    style={formStyles.textField}
                    value={rejectionReason}
                    readOnly
                    disabled
                  />
                </div>
              </div>
            )}
          </div>
        </div>

        {/* Document Details Section */}
        <div style={formStyles.section}>
          <div style={formStyles.sectionTitle}>
            <span style={formStyles.sectionNumber}>4.</span> Document Details
          </div>
          <div style={formStyles.sectionDescription}>Upload documents for verification.</div>

          <div style={formStyles.formRow}>
            <div style={formStyles.formColumnFull}>
              <label style={formStyles.inputLabel}>
                Add your Driver's License or Photo ID here <span style={formStyles.requiredStar}>*</span>
              </label>
              <div style={{ ...formStyles.uploadBox, height: (documentImage && documentImage.toLowerCase().includes(".pdf")) ? '700px' : "150px", overflow: 'auto !importat' }}>
                {documentImage ? (
                  // <img
                  //   src={documentImage || "/placeholder.svg"}
                  //   alt="Document"
                  //   style={{
                  //     maxHeight: "100%",
                  //     maxWidth: "100%",
                  //     objectFit: "contain",
                  //   }}
                  // />
                  documentImage.toLowerCase().includes(".pdf") ? (
                    <>
                      <iframe
                        src={`${documentImage}#toolbar=1&navpanes=0&view=FitH`}
                        title="PDF Document"
                        style={{
                          width: "100%",
                          height: "100%",
                          border: "none",
                          display: "block",
                        }}
                      />

                      {/* Action bar: open in new tab / replace file */}
                      <div
                        style={{
                          position: "absolute",
                          top: 8,
                          right: 8,
                          display: "flex",
                          gap: 8,
                          zIndex: 2,
                        }}
                      >
                        <a
                          href={documentImage}
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{
                            background: "#ADB792",
                            color: "#fff",
                            padding: "4px 10px",
                            height:'fit-content',
                            borderRadius: 4,
                            fontSize: 12,
                            textDecoration: "none",
                          }}
                        >
                          Open
                        </a>
                        <label
                          style={{
                            background: "#ADB792",
                            color: "#fff",
                            padding: "4px 10px",
                            borderRadius: 4,
                            fontSize: 12,
                            cursor: "pointer",
                          }}
                        >
                          Replace
                          <input
                            type="file"
                            accept="image/*,.pdf"
                            style={{ display: "none" }}
                            onChange={handleDocumentUpload}
                          />
                        </label>
                      </div>
                    </>
                  ) : (
                    <img
                      src={documentImage || "/placeholder.svg"}
                      alt="Document"
                      style={{
                        maxHeight: "100%",
                        maxWidth: "100%",
                        objectFit: "contain",
                      }}
                    />
                  )
                ) : (
                  <>
                    <div style={formStyles.uploadIcon}>
                      <Upload />
                    </div>
                    <div style={formStyles.uploadText}>Capture/Upload Here</div>
                  </>
                )}
                <input type="file" accept="image/*,.pdf" style={formStyles.fileInput} onChange={handleDocumentUpload} />
              </div>
            </div>
          </div>
        </div>

        {/* Write a Review Section */}
        <div style={formStyles.section}>
          <div style={formStyles.sectionTitle}>
            <span style={formStyles.sectionNumber}>5.</span> Shopper Application
          </div>
          <div style={formStyles.sectionDescription}>Final step: submit your application</div>
          <div style={formStyles.formRow}>
            <div style={formStyles.formColumnFull}>
              <label style={formStyles.inputLabel}>
                Please write a 150-200-character review of a recent customer service experience you have had at a store,
                restaurant or hotel. This should be fact-based <span style={formStyles.requiredStar}>*</span>
              </label>
              <textarea
                name="shoppperDetail"
                style={formStyles.textareaField}
                rows={5}
                value={formData.shoppperDetail}
                onChange={handleInputChange}
              ></textarea>
              <div style={formStyles.wordCount}>
                Words: {formData.shoppperDetail?.split(/\s+/).filter(Boolean).length || 0}
              </div>
            </div>
          </div>
        </div>

        <div style={formStyles.buttonContainer}>
          <Button variant="contained" className="table-row-background" onClick={() => handleSubmit()}>
            Save Changes
          </Button>
        </div>
      </div>
    </div>
  )
}

export default EditShopperProfile
